import { render, staticRenderFns } from "./TrainingDataAnalysisXunLian.vue?vue&type=template&id=ec88e358&scoped=true&"
import script from "./TrainingDataAnalysisXunLian.vue?vue&type=script&lang=js&"
export * from "./TrainingDataAnalysisXunLian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec88e358",
  null
  
)

export default component.exports